module.exports = __webpack_public_path__ + "img/cote_bottom_logo_04.0217f5c3.png";